import React from 'react';
import { getThemeComponent } from '@/utils/themeImports';
import { specificThemeRender } from '@/utils/specificThemeRender';
import { useSSRSelector } from '../../redux';

const AboutUs = () => {
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);
  return (
    <div className="PremiumAboutUs">
      {specificThemeRender(storeInfo)?.components?.Header?.map((layout) => {
        return getThemeComponent(layout.sub_type, layout.name, layout);
      })}
      <section className="PremiumAboutUs__wrapper">
        <div className="PremiumAboutUs__wrapper--inner">
          <div className="section-top">
            <h1 className="PremiumAboutUs--heading">About Us</h1>
            {storeInfo?.store_info?.description && (
              <p className="PremiumAboutUs--paragraph selected-text">
                {storeInfo?.store_info?.description}
              </p>
            )}
          </div>
          {specificThemeRender(storeInfo)?.components?.Footer?.map((layout) => {
            return getThemeComponent(layout.sub_type, layout.name, layout);
          })}
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
